<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="flex-none px-2">
      <h5 class="text-sm font-medium text-gray-600 mb-2">
        Comments &bull;
        <a role="button" class="text-blue-700" @click="commentFormVisible = true">Add Comment</a>
      </h5>
    </div>
    <div class="flex-1 lg:h-0">
      <div class="h-full overflow-y-auto fancy-scrollbar px-2">
        <div>
          <div v-if="commentFormVisible" class="bg-white p-4 rounded">
            <CommentForm :submit-action="addComment">
              <button type="button" class="btn btn-ghost ml-2" @click="commentFormVisible = false">
                Cancel
              </button>
            </CommentForm>
          </div>
          <Comments v-else :comments="comments" @comment-deleted="fetchComments" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Comments from '@/components/Comments/Index.vue';
import CommentForm from '@/components/Comments/CommentForm.vue';

export default {
  components: {
    Comments,
    CommentForm,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commentFormVisible: false,
    };
  },
  computed: {
    comments() {
      return this.$store.getters['ui/contactRequestComments/itemsByParent'](this.contactRequest.id);
    },
  },
  created() {
    this.fetchComments();
  },
  destroyed() {
    this.$store.dispatch('ui/contactRequestComments/clearByParent', {
      parentId: this.contactRequest.id,
    });
  },
  methods: {
    async fetchComments() {
      try {
        await this.$store.dispatch('ui/contactRequestComments/load', {
          id: this.contactRequest.id,
        });
      } catch (error) {
        //
      }
    },
    addComment(formData) {
      return this.$store
        .dispatch('ui/contactRequestComments/store', {
          id: this.contactRequest.id,
          formData,
        })
        .then((response) => {
          this.commentFormVisible = false;

          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
